(function () {
  if (window.gscInstagramHomeInit) return;

  const ROOT_SELECTOR = '.app-wrapper.gsc-instagram-home';
  const AVATAR_SIZE = 33;

  function createMeta(handle, avatarUrl) {
    const meta = document.createElement('div');
    meta.className = 'gsc-ig-item-meta';
    meta.setAttribute('aria-hidden', 'true');

    if (avatarUrl) {
      const avatar = document.createElement('img');
      avatar.className = 'gsc-ig-item-meta__avatar';
      avatar.src = avatarUrl;
      avatar.alt = '';
      avatar.width = AVATAR_SIZE;
      avatar.height = AVATAR_SIZE;
      avatar.loading = 'lazy';
      avatar.decoding = 'async';
      meta.appendChild(avatar);
    }

    if (handle) {
      const handleEl = document.createElement('span');
      handleEl.className = 'gsc-ig-item-meta__handle';
      handleEl.textContent = handle;
      meta.appendChild(handleEl);
    }

    return meta;
  }

  // Idempotent: only decorates media items that do not have the meta yet
  function decorate(root) {
    const handle = root.getAttribute('data-ig-handle');
    const avatarUrl = root.getAttribute('data-ig-avatar');
    if (!handle && !avatarUrl) return;

    root.querySelectorAll('.gfa-media').forEach((media) => {
      if (media.querySelector(':scope > .gsc-ig-item-meta')) return;
      media.appendChild(createMeta(handle, avatarUrl));
    });
  }

  // The app widget renders (and re-renders / clones slides) asynchronously, so watch for new items
  function watch(root) {
    decorate(root);
    if (root.__gscIgObserver) return;

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(() => {
        scheduled = false;
        decorate(root);
      }, 50);
    });

    observer.observe(root, { childList: true, subtree: true });
    root.__gscIgObserver = observer;
  }

  function init(scope) {
    const container = scope && scope.querySelectorAll ? scope : document;
    if (container.matches && container.matches(ROOT_SELECTOR)) {
      watch(container);
      return;
    }
    container.querySelectorAll(ROOT_SELECTOR).forEach(watch);
  }

  window.gscInstagramHomeInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.addEventListener('load', () => init());

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    init(event.target.closest('.shopify-section') || undefined);
  });
})();
